<template>
    <div class="cart-buy-widget" :class="{'extend-widget' : pointsPurchaseButton}" :key="floatBtn.mode" id="cartBuyWidget" ref="cartBuyWidget">
        <button
            class="cart-buy-button"
            :class="{'notify-me': floatBtn.mode === 'notify-me' || floatBtn.mode == 'temp-unavailable' || floatBtn.mode === 'out-of-stock', 'lock-button' : lockButton}"
            data-mub-skip="y"
            :disabled="disabled"
            @click.prevent="$emit('float-btn-routing'); $emit('handle-warnings');"
        >
            {{ buttonLabel }}
            <span class="p-bar-btn" :class="{'warning-mode' : warningLabel}" id="progressBarContainer">
                <span class="btn-bar" :class="{'reset-bar' : floatBtn.loadingBar == 0 , 'fill-bar' : floatBtn.loadingBar == 100}" :style="{width: `${floatBtn.loadingBar <= 99 ? floatBtn.loadingBar : 100}%`}" id="btnProgressbar"/>
                <i v-if="floatBtn.loadingBar == 100" :class="[!warningLabel ? 'prz-checkmark' : 'prz-info' ]">
                    {{ warningLabel }}
                </i>
            </span>
        </button>
        <p v-if="cartWarningLabel" class="cart-warning">  <i class="prz-info"/> {{ cartWarningLabel }} </p>
        <button v-if="pointsPurchaseButton"
                class="cart-buy-button secondary-btn"
                :disabled="disablePointsButton"
                @click.prevent="$emit('float-btn-routing', true)"
            >
              <span class="p-bar-btn">
                  <span class="btn-bar" :class="{'reset-bar' : pointsPurchaseButton.loadingBar == 0 , 'fill-bar' : pointsPurchaseButton.loadingBar == 100}" 
                    :style="{width: `${pointsPurchaseButton.loadingBar <= 99 ? pointsPurchaseButton.loadingBar : 100}%`}" 
                    id="btnPointsProgressbar"/>
                  <i v-if="pointsPurchaseButton.loadingBar != 100" class="prz-prozis-points small"/>
                  <i v-if="pointsPurchaseButton.loadingBar == 100" :class="[!pointsWarningLabel ? 'prz-checkmark' : 'prz-info']">
                     {{ pointsWarningLabel }}
                  </i>
                  {{ pointsButtonLabel }}
              </span>
        </button>
        <p v-if="pointsNoticeLabel" class="outer-notice-label" :class="{'no-events' : cartQty == 0}" @click="showPointsModal = true">
            <i class="prz-info"/> <span v-html="pointsNoticeLabel"/>
        </p>
        <transition name="fade">
            <BlockContentPopup
                v-if="showPointsModal"
                :modal-mode="true"
                :header-title="kStrings.kREDEEM_PROZIS_POINTS"
                id="pointsPurchaseModal"
                class="points-purchase-modal"
                :stacked-modal="true"
                @close="showPointsModal = false"
            >
                <template v-slot:content>
                    <div class="popup-content points-purchase-widget">
                        <p class="content-text with-label"> {{ kStrings.kGLOB_YOU_HAVE }} <span class="text-label"> <i class="prz-prozis-points"/> {{ floatBtn.pointsBtn.availablePoints }} </span> </p>
                        <p class="content-text description-text" v-html="floatBtn.pointsBtn.modalDescription"/>
                        <button class="widget-button" :disabled="disablePointsButton" @click.prevent="$emit('float-btn-routing', true); showPointsModal = false"> <i class="prz-prozis-points"/> {{ floatBtn.pointsBtn.label }} </button>
                    </div>
                </template>
            </BlockContentPopup>
        </transition>
    </div>
</template>

<script>

import {storePdp} from '@/store/product-page';
import CampaignDisplay from "@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/Content/CampaignDisplay.vue";
import CopyToClipboard from "@/components/Muffin/CopyToClipboard.vue";

export default {
    storePdp,
    name: 'FloatButton',
    components: {
        CopyToClipboard,
        CampaignDisplay,
        BlockContentPopup: () => import("@/components/ProductPage/Desktop-BlackRabbit/BlocksSection/BlockContentPopup.vue"),
    },
    props: {
        lockButton: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        detached: {
            type: Boolean,
            default: false,
        },
    },
    data: function() {
        return {
            showPointsModal: false,
        };
    },

    computed: {
        /*buttonId() {
            if(this.detached) {
                return 'floatBuyWidget';
            }
            
            return 'cartBuyWidget'
        },*/
        kStrings() {
            return storePdp.getters.kStrings;
        },
        floatBtn() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/floatBtn']; 
        },
        buttonLabel() {
            if(this.floatBtn.loadingBar == 100) {
                return '';
            }
            
            return !this.floatBtn.warningLabel ? this.floatBtn.label : '';
        },
        warningLabel() {
            if(this.floatBtn.loadingBar != 100) {
                return '';
            }
            
            return this.floatBtn.warningLabel;
        },
        globalCartWarningEvent() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/globalCartWarningEvent'];
        },
        cartWarningLabel() {
            if(!this.globalCartWarningEvent) {
                return null;
            }

            return this.floatBtn.selectionWarning;
        },
        pointsPurchaseButton() {
            if(!storePdp.getters.enablePointsPurchase) {
                return null;
            }
            return this.floatBtn.pointsBtn && !this.floatBtn.pointsBtn.hide ? this.floatBtn.pointsBtn : null;
        },
        pointsButtonLabel() {
            if(!this.pointsPurchaseButton || this.pointsPurchaseButton.loadingBar == 100) {
                return '';
            }

            return !this.pointsPurchaseButton.warningLabel ? this.pointsPurchaseButton.label : '';
        },
        pointsWarningLabel() {
            if(!this.pointsPurchaseButton ||this.pointsPurchaseButton.loadingBar != 100) {
                return '';
            }

            return this.pointsPurchaseButton.warningLabel;
        },
        disablePointsButton() {
            if(!this.pointsPurchaseButton) {
               return null;
            }

            if(this.cartPointsInfo && (this.cartPointsInfo.immersiveTotal < this.pointsPurchaseButton.cost)) { // on cart update
                return true;
            }

            return this.cartQty == 0 || (this.pointsPurchaseButton.disabled || this.disabled);
        },
        pointsNoticeLabel() {
            if (!this.pointsPurchaseButton) {
                return '';
            }

            if(this.cartQty == 0) {
              return this.kStrings.kADD_PRODUCTS_FOR_POINTS_REDEEM;
            }

            return !this.floatBtn.detached && (this.pointsPurchaseButton && this.pointsPurchaseButton.noticeLabel);
        },
        cartQty() {
            return storePdp.getters['pdpDesktop/addToCartDesktop/headerCartQty'];
        },
        cartPointsInfo() {
            return storePdp.getters.cartPointsInfo;
        }
    },
    //methods: {},
    //watch: {},
    mounted() {
        this.$nextTick(() => {
            storePdp.dispatch('pdpDesktop/initMovingElementsBehaviour');
        })
    },
};
</script>

<style lang="scss">
@import "../styles/floatBtn";
</style>
